module.exports = {
  DomesticTrade: 'การค้าภายในประเทศ',
  SiruiPleaseContactTheTroubleshooting: 'การส่งคำสั่งซื้อของ Sirui ล้มเหลว โปรดติดต่อเจ้าหน้าที่เพื่อตรวจสอบ:',
  OperationFailed: 'การดำเนินการล้มเหลว',
  PleaseCheckTheData: 'โปรดเลือกข้อมูล',
  LockedContactAHigherUnlock: 'ถูก锁定แล้ว ไม่สามารถพิมพ์ได้ โปรดติดต่อผู้ดูแลเพื่อปลดล็อก!',
  AreCancelTheVoidingDocuments: 'แน่ใจหรือไม่ที่จะยกเลิกการทำเอกสารที่เลือกให้เป็นโมฆะ?',
  PleaseFormInvoiceEtcVoid: 'โปรดลบใบยืนยันค่าใช้จ่ายและบิลก่อน แล้วจึงทำเป็นโมฆะ',
  PleaseFromTheMasterVoid: 'โปรดนำตั๋วย่อยนี้ออกจากตั๋วหลักก่อน แล้วจึงทำเป็นโมฆะ',
  PleaseFromThisMasterVoid: 'โปรดนำตั๋วย่อยทั้งหมดออกจากตั๋วหลักนี้ แล้วจึงทำเป็นโมฆะ',
  ThisThatRelevantDocumentsContinue: 'งานในใบนี้จะถูกส่งให้ฝ่ายการเงินตรวจสอบ ก่อนส่งโปรดยืนยันว่าได้อัปโหลดไฟล์ที่เกี่ยวข้องแล้ว ต้องการดำเนินการต่อหรือไม่?',
  AttachmentContentIsTooLarge: 'เนื้อหาของไฟล์แนบมีขนาดใหญ่เกินไป',
  ThereBillNumbersProfitPrinted: 'มีค่าใช้จ่ายต่างประเทศที่ไม่มีหมายเลขบิลที่ถูกต้อง ไม่สามารถพิมพ์รายงานวิเคราะห์กำไรได้!',
  ThereBillNumbersProfitSubmitted: 'มีค่าใช้จ่ายต่างประเทศที่ไม่มีหมายเลขบิลที่ถูกต้อง ไม่สามารถส่งรายงานวิเคราะห์กำไรได้!',
  LockedPrintedOrEDINeeded: 'เนื่องจากเกินวงเงินเครดิต ตั๋วนี้ถูก锁定แล้ว จะไม่สามารถพิมพ์หรือใช้ EDI ได้ โปรดติดต่อผู้ดูแลเพื่อปลดล็อกเมื่อต้องการ',
  PleaseTicketToBeAdded: 'โปรดเลือกตั๋วย่อยที่ต้องการเพิ่ม',
  AreCopyTheMastersInformation: 'แน่ใจหรือไม่ที่จะคัดลอกข้อมูลผู้ส่งและผู้รับของตั๋วหลัก?',
  MasterPleaseMaintainTheFirst: 'หมายเลขตั๋วหลักไม่สามารถเว้นว่างได้ โปรดกรอกหมายเลขตั๋วหลักก่อน',
  PleaseTicketToBeEdited: 'โปรดเลือกตั๋วย่อยที่ต้องการแก้ไข',
  Add: 'เพิ่มใหม่',
  AirImportCargoOperationDetails: 'รายละเอียดการดำเนินการสินค้านำเข้าทางอากาศ',
  ThisAlreadyAFormalBusiness: 'ตั๋วนี้เป็นงานอย่างเป็นทางการแล้ว'
}
